/**
 * @desc 导出
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.transfer.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/transfer/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
